import { loadLargeImage } from '../articleImage';
import LandingpagePresenter from '../../landingpagePresenter';
import Header from './header';
import HeadlineHeader from './headlineHeader';
import Questions from './questions';
import Answer from './answer';
import FormRenderer from '../forms/formRenderer';
import VideoRenderer from '../videos/videoRenderer';
import WidgetRenderer from '../widgets/widgetRenderer';
import BrowserLocation from '../../browserLocation';
import React from 'react';
import $ from 'jquery';
import AOS from 'aos';

class Landingpage extends React.Component {
  constructor() {
    super();
    this.state = {
      article: LandingpagePresenter.nullArticle(),
      widgets: []
    };
  }

  componentWillMount() {
    this.ajaxArticle();
  }

  componentDidMount() {
    this.toggleFlyingWidget();
    AOS.init();
  }

  ajaxArticle() {
    const loadExternalData = BrowserLocation.uriParams().h || false;
    const methods = [
      'selected_layout',
      'image_focus_hintergrund_mini',
      'image_focus_hintergrund_teaser',
      'image_focus_hintergrund_background',
      'image_teaser_teaser',
      'widget_ids',
      'landingpage_headline_1',
      'landingpage.claim_1',
      'landingpage.hint_1',
      'landingpage_question_videos',
      'landingpage_answer_video',
      'landingpage.answer_content',
      'landingpage.headline_2',
      'landingpage.claim_2',
      'content_article_forms',
      'landingpage.v_check',
      'landingpage.flying_widget_text',
      'landingpage.flying_widget_button_text',
      'landingpage.phone_number'
    ].join();

    $.ajax({
      url: `/api/v3/articles/${this.props.articleId}.json?methods=${methods}&load_external_data=${loadExternalData}`,
      method: 'GET',
      success: data => {
        if (data !== undefined && data !== null) {
          this.setState({ article: LandingpagePresenter.getArticle(data) }, function () {
            loadLargeImage(this);
            this.renderQuestionVideoModals(this.state.article.landingpage.questionVideos);
            VideoRenderer.renderVideoModal(this.state.article.landingpage.answerVideo);
            WidgetRenderer.widgetsForObject(this.state.article, widgets => {
              this.setState({ widgets });
            });
          });
        }
      },
      error: (xhr, status, err) => console.error(this.props.articleId, status, err.toString())
    });
  }

  toggleFlyingWidget() {
    $('.flying-widget').toggleClass('flying-widget-closed flying-widget-opened');
  }

  goToForm(e) {
    e.stopPropagation();
    if ($('#tukur-form').length) {
      // smooth scroll to the form
      $('body, html').animate({ scrollTop: $('#tukur-form').offset().top }, 500);
    }
  }

  renderQuestionVideoModals(questionVideos) {
    questionVideos.map(questionVideo => VideoRenderer.renderVideoModal(questionVideo));
  }

  render() {
    const flyingWidgetImageSrc = this.state.article.landingpage.vCheck
      ? '/system/images/503/original/v-check-icon.png'
      : '/system/images/504/original/Quirin_Buch_liegend.png';

    return (
      <div>
        {this.state.article.layout === LandingpagePresenter.LANDINGPAGE_LAYOUTS[1] ? (
          <HeadlineHeader article={this.state.article} widgets={this.state.widgets} />
        ) : (
          <Header article={this.state.article} widgets={this.state.widgets} />
        )}

        <div className="container">
          <div className="row">
            <aside className="sidebar">&nbsp;</aside>
            <article className="content no-margin">
              {WidgetRenderer.renderWidgets(this.state.widgets, 'main-content')}

              {this.state.article.layout === LandingpagePresenter.LANDINGPAGE_LAYOUTS[1] && (
                <Questions article={this.state.article} />
              )}
              <Answer article={this.state.article} />
            </article>
            <aside className="spacebar">&nbsp;</aside>
          </div>
        </div>

        {WidgetRenderer.renderWidgets(this.state.widgets, 'main-content-before-form')}

        <div id="tukur-form" style={{ backgroundColor: '#fff', position: 'relative', zIndex: 3 }}>
          <div className="container">
            <div className="row">
              <aside className="sidebar">&nbsp;</aside>
              <article className="landingpage-form content margin-top-lg margin-bottom-lg">
                {!this.state.article.landingpage.vCheck &&
                  this.state.article.landingpage.imageForm && (
                    <div className="pull-left">
                      <img
                        alt=""
                        src={this.state.article.landingpage.imageForm}
                        className="img-responsive"
                      />
                    </div>
                  )}
                <div className={!this.state.article.landingpage.vCheck ? 'pull-right' : ''}>
                  {this.state.article.landingpage.headline2 && (
                    <h2 className="no-margin">{this.state.article.landingpage.headline2}</h2>
                  )}
                  {this.state.article.landingpage.claim2 && (
                    <p>{this.state.article.landingpage.claim2}</p>
                  )}
                  {this.state.article.landingpage.vCheck ? (
                    <div className="iframe-wrapper">
                      <iframe
                        src="https://backup.quirinbank.de/vermogens-check-quirin-neu?iframe=true&amp;hide-col-580=true&amp;quirin=true&amp;referrer=Web_qpb_tukur&amp;responsive=true&amp;utm_source=lp_tukur&amp;utm_campaign=v-check-2017"
                        width="100%"
                        height="1621"
                      />
                    </div>
                  ) : (
                    FormRenderer.displayFor(this.state.article, 'main_content')
                  )}
                </div>
              </article>
              <aside className="spacebar">&nbsp;</aside>
            </div>
          </div>
        </div>

        {WidgetRenderer.renderWidgets(this.state.widgets, 'further-content')}

        <div className="flying-widget text-center hidden-mobile flying-widget-closed">
          <span className="close-flying-widget fa fa-close" onClick={this.toggleFlyingWidget} />
          <div className="flying-widget-content">
            <img
              alt=""
              src={flyingWidgetImageSrc}
              className="img-responsive img-link margin-bottom-xxs margin-top-xs center-x"
              onClick={this.goToForm}
            />
            <p className="text-uppercase margin-bottom-xxs bordered-p">
              {this.state.article.landingpage.flyingWidgetText}
            </p>
            <a
              className="button button-invert button-multi-line no-margin"
              href="#"
              onClick={this.goToForm}
            >
              {this.state.article.landingpage.flyingWidgetButtonText}
            </a>
          </div>
          {this.state.article.landingpage.phoneNumber && (
            <div className="flying-widget-content">
              <h4 className="text-uppercase no-margin">
                <div className="color-text">Rufen Sie uns kostenlos an</div>
                <a href={`tel:${this.state.article.landingpage.phoneNumber.replace(/\s/g, '')}`}>
                  {this.state.article.landingpage.phoneNumber}
                </a>
              </h4>
            </div>
          )}
        </div>
      </div>
    );
  }
}

Landingpage.propTypes = {
  articleId: React.PropTypes.number
};

export default Landingpage;



// WEBPACK FOOTER //
// ./components/landingpage/landingpage.js